import {hasCookieConsentMarketing, loadYoutubeAPI} from "../../utils/Utils.js";

const YouTubeEmbed = (blockElem, autoEmbedOnLoad) => {

	const youtubeId = blockElem.getAttribute('data-src');
	if(!youtubeId) {
		return;
	}

	let player = null;
	const placeholder = blockElem.querySelector('.placeholder');
	const poster = blockElem.querySelector('.poster');
	poster.addEventListener('click', (e) => {
		e.preventDefault();

		const consentGiven = hasCookieConsentMarketing();

		if(!consentGiven) {

			// Use this if we're going to show an "alert" instead
			const cookieCompliance = blockElem.querySelector('.cookie-compliance-video');
			if(cookieCompliance) {
				cookieCompliance.classList.add('js-revealed');
				blockElem.classList.add('js-cookie-compliance-revealed');

				if(!cookieCompliance.hasAttribute('tabindex')) {
					cookieCompliance.setAttribute('tabindex', '0');
				}
				cookieCompliance.focus();
			}
			else {
				if(youtubeId.includes('http')) {
					window.open(youtubeId);
				}
				else {
					window.open(`https://www.youtube.com/watch?v=${youtubeId}`);
				}
			}
		}
		else {
			loadVideo();
			blockElem.classList.remove('js-cookie-compliance-revealed');
		}
	});

	const loadVideo = () => {

		blockElem.classList.add('js-playing');

		if(player) {
			player.playVideo();
		}
		else {

			loadYoutubeAPI(() => {

				const options = {
					videoId: youtubeId,
					//host: 'https://www.youtube-nocookie.com',
					width: '1600',
					height: '900',
					playerVars: {
						modestbranding: 1,
						playsinline: 1,
						rel: 0,
						autoplay: 1,
					},
					events: {
						//'onReady': onPlayerReady,
						'onStateChange': (e) => {
							if(e.data === YT.PlayerState.ENDED) {
								hideVideo();
							}
						}
					}
				};
				player = new YT.Player(placeholder, options);
			});
		}
	};

	const hideVideo = () => {
		blockElem.classList.remove('js-playing');
	};

	if(autoEmbedOnLoad) {
		loadVideo();
	}
};

export default YouTubeEmbed;